import styled from 'styled-components';

const WhiteBackground = styled.div`
  align-items: center;
  background-color: #ffffff;
  border-radius: 50%;
  display: flex;
  height: 32px;
  justify-content: center;
  width: 32px;
`;

const Styled = {
  WhiteBackground,
};

export default Styled;
